import { liveCountLabel } from '@/lib/live-count';

/**
 * The small grey count beside a heading or inside a button — how many live
 * calls there are. Shared by the Live Calls header and the Live Calls button
 * on the Calls page so the two read as the same number. Renders nothing at
 * zero: "0" next to Live Calls is noise, not information.
 */
export function CountChip({ count }: { count: number }): React.ReactElement | null {
  if (count <= 0) return null;
  return (
    <span className="rounded-md bg-muted px-1.5 py-px text-xs font-semibold text-muted-foreground">
      {liveCountLabel(count)}
    </span>
  );
}
